/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Breadcrumb from '../../components/Common/Breadcrumb';
import { BASE_URL_IMAGE } from '../../config/api';
import { fetchNewsWithAuthorById } from '../../services/newsService';
import '../../assets/css/NewsDetails.css';

const NewsDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetchNewsWithAuthorById(id);
        setNews(response);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [id]);

  const breadcrumbItems = [
    { label: "News", path: "/news" },
    { label: "View News" },
  ];

  if (loading) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar id="menu-item11" id1="menu-items11" activeClassName="blog-details" />
        <div className="page-wrapper">
          <div className="content text-center py-5">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar id="menu-item11" id1="menu-items11" activeClassName="blog-details" />
        <div className="page-wrapper">
          <div className="content text-center py-5 text-danger">{error}</div>
        </div>
      </div>
    );
  }

  if (!news) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar id="menu-item11" id1="menu-items11" activeClassName="blog-details" />
        <div className="page-wrapper">
          <div className="content text-center py-5">News not found</div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar id="menu-item11" id1="menu-items11" activeClassName="blog-details" />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <Breadcrumb items={breadcrumbItems} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="news-view">
                <div className="news-header">
                  <h1 className="news-title">{news.news_title}</h1>
                  <div className="news-meta">
                    <div className="meta-item">
                      <FeatherIcon icon="user" size={16} />
                      <span>{news.user_name || 'Unknown'}</span>
                    </div>
                    <div className="meta-divider">•</div>
                    <div className="meta-item">
                      <FeatherIcon icon="calendar" size={16} />
                      <span>{new Date(news.createdAt).toLocaleDateString("en-GB")}</span>
                    </div>
                  </div>
                </div>

                {/* Images */}
                <div className="news-images">
                  {news.news_banner && (
                    <img
                      className="news-banner"
                      src={`${BASE_URL_IMAGE}/uploads/newsImages/${news.news_banner}`}
                      alt="News Banner"
                    />
                  )}
                  {/* {news.news_thumbnail && (
                    <img
                      className="news-thumbnail"
                      src={`${BASE_URL_IMAGE}/uploads/newsImages/${news.news_thumbnail}`}
                      alt="News Thumbnail"
                    />
                  )} */}
                </div>

                <div className="news-content">
                  <p>{news.news_description}</p>
                </div>

                {/* Tags */}
                {news.tags && (
                  <div className="news-tags">
                    <h5>Tags:</h5>
                    <div className="tags-container">
                      {news.tags.split(',').map((tag, index) => (
                        <span key={index} className="tag">#{tag.trim()}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Sidebar - Author Info */}
            <div className="col-lg-4 col-md-12">
              <div className="author-profile-card">
                <img
                  className="profile-image-circle"
                  alt="Author"
                  src={`${BASE_URL_IMAGE}/uploads/userProfiles/${news.user_profile_img || "default.png"}`}
                />
                <div className="profile-info">
                  <h4 className="profile-name">{news.user_name || 'Unknown author'}</h4>
                  <p className="profile-role">{news.user_designation || 'Contributor'}</p>
                  <p className="profile-bio">{news.user_biography || 'No bio available'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-overlay" data-reff="" />
    </div>
  );
};

export default NewsDetails;
